import React from 'react';

const HighlightedBlock = () => (
  <section className='highlighted-block highlighted-block--alt'>
    <div className='container'>
      <div className='highlighted-block__card'>
        <ul className='highlighted-block__filter-icons'>
          <li>
            <span>🐶 </span>
            <strong>Livio 😊</strong>
          </li>
          <li>
            <span>🤧</span>
            <strong>Jovan 👋</strong>
          </li>
          <li>
            <span>🚧</span>
            <strong>Michael 😃</strong>
          </li>
          <li>
            <span>👶</span>
            <strong>Jeannie 🙌</strong>
          </li>
        </ul>
        <div className='highlighted-block__content'>
          <h2 className='highlighted-block__title'>Curious can-doers welcome.</h2>
          <div className='highlighted-block__description'>
            <p>
              We question how everything is done. It’s a trait that can be annoying to friends and family
              members but has served us well. We’re great at seeing problems and even better at fixing
              them. Can you relate?
              <br />
              {' '}
              You’re gonna like it here.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HighlightedBlock;
